// extracted by mini-css-extract-plugin
module.exports = {"full":"FavoriteBtn-module--full---6ACw","favoriteBtn":"FavoriteBtn-module--favoriteBtn--2MnpC"};